import { parsePhoneNumberFromString } from 'libphonenumber-js'

// Detect a phone field by name. Simple heuristic per requirement: contains "phone"
export const isPhoneFieldName = (fieldPath: string): boolean => {
  const last = fieldPath.split('.').pop()?.toLowerCase() ?? ''
  const candidates = new Set([
    'phone',
    'phonenumber',
    'phone_number',
    'telephone',
    'mobile',
    'mobilephone',
    'cell',
    'cellphone',
    'text_from_number',
  ])
  return candidates.has(last)
}

// Remove all non-digit characters
export const extractDigits = (value: string): string => value.replace(/\D/g, '')

// Format as (XXX) XXX - XXXX from any partial numeric input (max 10 digits)
export const formatUsPhoneInput = (raw: string): string => {
  let digits = extractDigits(raw)

  // Disallow leading 1/0 for national number
  if (digits.startsWith('1') || digits.startsWith('0')) {
    digits = digits.slice(1)
  }

  digits = digits.slice(0, 10)

  if (digits.length === 0) return ''
  if (digits.length < 4) return `(${digits}`
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)} - ${digits.slice(6)}`
}

// Convert formatted/numeric input to E.164 +1XXXXXXXXXX (US only)
export const toE164Us = (raw: string): string | undefined => {
  const digits = extractDigits(raw)
  if (digits.length === 0) return undefined
  const national = digits.slice(-10) // take last 10 digits
  if (national.length !== 10) return undefined
  try {
    const phone = parsePhoneNumberFromString(`+1${national}`)
    return phone ? phone.number : `+1${national}`
  } catch {
    return `+1${national}`
  }
}

// Extract alphanumeric characters (A-Z, 0-9) from input
export const extractAlphanumeric = (value: string): string =>
  value.replace(/[^A-Z0-9]/gi, '').toUpperCase()

// Format as XX-YYYY-YYYY from any partial alphanumeric input (max 10 chars)
// Format: XX-YYYY-YYYY where XX is 2 uppercase letters, YYYY-YYYY is 8 alphanumeric chars
export const formatUserIdInput = (raw: string): string => {
  let chars = extractAlphanumeric(raw)
  chars = chars.slice(0, 10) // Max 10 characters

  if (chars.length === 0) return ''
  if (chars.length <= 2) return chars
  if (chars.length <= 6) return `${chars.slice(0, 2)}-${chars.slice(2)}`
  return `${chars.slice(0, 2)}-${chars.slice(2, 6)}-${chars.slice(6)}`
}
